import * as React from "react";
import styled, { css } from "styled-components";
import { Trans, useTranslation } from "react-i18next";
import { Alert } from "components/bootstrap";
import { Link } from "components/common";
import Routes from "routing/Routes";
const Reasons = styled.ul(
  ({ theme }) => css`
    list-style: disc;
    margin: ${theme.spacings.xs} 0 ${theme.spacings.sm};
    padding-left: ${theme.spacings.lg};

    li {
      margin-bottom: ${theme.spacings.xxs};
    }
  `
);
const DataLakeStreamDeleteWarning = ({ streamId, isEnabled, hasArchivedData, hasRetrievals }) => {
  const { t } = useTranslation("enterprise_data_lake");
  return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger", title: t("stream_delete_warning.title") }, /* @__PURE__ */ React.createElement(Reasons, null, isEnabled && /* @__PURE__ */ React.createElement("li", null, t("stream_delete_warning.routing")), hasArchivedData && /* @__PURE__ */ React.createElement("li", null, t("stream_delete_warning.archived")), hasRetrievals && /* @__PURE__ */ React.createElement("li", null, t("stream_delete_warning.retrievals"))), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "stream_delete_warning.resolve",
      components: {
        dataLakeLink: /* @__PURE__ */ React.createElement(Link, { to: `${Routes.stream_view(streamId)}?segment=destinations` })
      }
    }
  )));
};
export default DataLakeStreamDeleteWarning;
